import React from "react";
import styles from "./styles/DashboardCard.module.css";
import { CardTitle, ImageWithPlaceholder } from "../CustomComponents";
import profile from '../../assets/images/dispatcher_profile.png'

const DispatcherCard = ({ data }) => {
  function beatColor(beatCount) {
    if (beatCount >= 95 && beatCount <= 240) {
      return "#FF0000";
    } else if (beatCount >= 85 && beatCount < 95) {
      return "#FE740B";
    } else if (beatCount >= 40 && beatCount < 85) {
      return "#23AD23";
    }
    return "#000";
  }

  return (
    <div className={`${styles.Card}`}>
      <div className="border-end w-50">
        <div className={`${styles.iconCard}`}>
          {/* <img src={data.image_url} alt="Officer" className={styles.profileImage}/> */}
          <ImageWithPlaceholder
            src={data.image_url}
            placeholder={"/images/user-placeholder.jpeg"}
            alt="post"
            className={styles.profileImage}
          />
        </div>
        <CardTitle
          text={data.name}
          classes={`text-black fw-bold mt-2 text-capitalize ${styles.cardText}`}
        />
      </div>
      <div>
        <p className={`mb-4 ${styles.cardText}`}>Heart Beat</p>
        <p
          className="fs-2 fw-bold m-0"
          style={{ color: beatColor(data.heart_rate) }}
        >
          {data.heart_rate}
          <span className="fs-6 text-black">BMP</span>
        </p>
      </div>
    </div>
  );
};

export default DispatcherCard;
